<client-document-item #clientDocumentItem [model]="model" [extended]="true" [isDocumentDisplay]="true" [documentType]="documentType" [documentsNavigator]="documentsNavigator"
    (close)="this.close.emit()">
</client-document-item>